import {createSelector} from '@ngrx/store';
import {ChallengeView, Project} from '../../model/project';
import {AppState} from '../app-state';

export const selectProjectsState = (state: AppState) => state.projects;

export const selectAllProjects = (withChallenges?: boolean) =>
  createSelector(selectProjectsState, state =>
    withChallenges ? state.projects : state.projects?.filter(p => !p.isChallenge)
  );

export const selectProjectsSummary = createSelector(selectProjectsState, state => state.projectsSummary);

export const selectProjectsMap = createSelector(selectProjectsState, state => state.projectsMap);

export const selectProject = (id: string) =>
  createSelector(selectProjectsMap, projectsMap => projectsMap[id] || ({} as Project));

export const selectProjectViews = createSelector(selectProjectsState, state => state.projectViews);

export const selectProjectViewTaskId = createSelector(selectProjectsState, state => state.projectViewTaskId);

export const selectProjectViewRoutineDetailMap = createSelector(selectProjectsState, state => state.routineDetailMap);

export const selectTaskTemplates = createSelector(selectProjectsState, state => state.taskTemplates);

export const selectProjectViewRoutineDetailParams = createSelector(
  selectProjectsState,
  state => state.projectViewRoutineDetailParams
);

export const selectProjectViewTokenFilterParams = createSelector(
  selectProjectsState,
  state => state.projectViewTokenFilterParams
);

export const selectTwdSubtaskView = createSelector(selectProjectsState, state => state.twsSubtaskView);

export const selectRepeatingTaskHistoryMap = createSelector(
  selectProjectsState,
  state => state.repeatingTaskHistoryMap
);

export const selectProjectViewScrollPosition = createSelector(
  selectProjectsState,
  state => state.projectViewScrollPosition
);

export const selectCurrentProjectsRoute = createSelector(selectProjectsState, state => state.currentProjectsRoute);

export const selectProjectChallengeMap = createSelector(selectProjectsState, state => state.projectChallengeMap);

export const selectProjectChallenge = (id: string) =>
  createSelector(selectProjectChallengeMap, challengeMap => challengeMap[id] || (null as ChallengeView | null));
